export * from './wizard-config.component';